/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { WebhookMessage } from '../model/webhookMessage';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WhatsappControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente di ricevere messaggi su webhook
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricezioneMessaggio(body: WebhookMessage, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public ricezioneMessaggio(body: WebhookMessage, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public ricezioneMessaggio(body: WebhookMessage, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public ricezioneMessaggio(body: WebhookMessage, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling ricezioneMessaggio.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/v1/whatsapp/webhook`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di verificare il webhook
     * @param hub_mode 
     * @param hub_challenge 
     * @param hub_verify_token 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verificaWebhook(hub_mode: string, hub_challenge: string, hub_verify_token: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public verificaWebhook(hub_mode: string, hub_challenge: string, hub_verify_token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public verificaWebhook(hub_mode: string, hub_challenge: string, hub_verify_token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public verificaWebhook(hub_mode: string, hub_challenge: string, hub_verify_token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (hub_mode === null || hub_mode === undefined) {
            throw new Error('Required parameter hub_mode was null or undefined when calling verificaWebhook.');
        }

        if (hub_challenge === null || hub_challenge === undefined) {
            throw new Error('Required parameter hub_challenge was null or undefined when calling verificaWebhook.');
        }

        if (hub_verify_token === null || hub_verify_token === undefined) {
            throw new Error('Required parameter hub_verify_token was null or undefined when calling verificaWebhook.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (hub_mode !== undefined && hub_mode !== null) {
            queryParameters = queryParameters.set('hub.mode', <any>hub_mode);
        }
        if (hub_challenge !== undefined && hub_challenge !== null) {
            queryParameters = queryParameters.set('hub.challenge', <any>hub_challenge);
        }
        if (hub_verify_token !== undefined && hub_verify_token !== null) {
            queryParameters = queryParameters.set('hub.verify_token', <any>hub_verify_token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/v1/whatsapp/webhook`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
